import * as React from 'react'

const SvgIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='29'
    height='28'
    fill='none'
    viewBox='0 0 29 28'
    {...props}
  >
    <path
      stroke='#6E6E73'
      strokeLinecap='round'
      strokeWidth='4'
      d='M14.938 2v24M26.939 14h-24'
    ></path>
  </svg>
)

export default React.memo(SvgIcon)
